import { FETCH_USER_DETAILS_FAILURE, FETCH_USER_DETAILS_REQUEST, FETCH_USER_DETAILS_SUCCESS } from "./actionCreator";

const initialState = {
  loading: false, 
  user: {},      
  error: null,
};

const userDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USER_DETAILS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_USER_DETAILS_SUCCESS:
      return { ...state, loading: false, user: action.payload, error: null };
    case FETCH_USER_DETAILS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default userDetailsReducer;